
import React from 'react';
import { motion } from "framer-motion";

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};

export const ChallengeStepContent: React.FC = () => {
  return (
    <motion.div 
      className="p-5 bg-web3-blue/10 rounded-lg mt-4 border border-web3-blue/30 flex-grow"
      variants={itemVariants}
    >
      <h4 className="font-medium text-web3-green mb-3 text-lg">Key Performance Indicators (KPIs)</h4>
      <div className="grid grid-cols-2 gap-4">
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Uptime</h5>
          <p className="text-white/80">How consistently your mining operation runs</p>
        </div>
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Energy Cost</h5>
          <p className="text-white/80">Your cost per kilowatt hour (lower is better)</p>
        </div>
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Profit Margin</h5>
          <p className="text-white/80">Your operation's profitability percentage</p>
        </div>
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Efficiency</h5>
          <p className="text-white/80">How effectively you're using your resources</p>
        </div>
      </div>
    </motion.div>
  );
};
